import { fetchServerXBasicAuthNative } from '@wiggot/utils/src/fetch-server-native'
import { deleteCookiesAuth } from '../utils'

const WIGGOT_API = process.env.WIGGOT_API

export const removeSession = () => {
  deleteCookiesAuth()
  window.location.replace('/')
}

export const fetchRemoveSession = async ({
  userId
}: {
  userId: string
}) => {
  const profileData = {
    userId,
    source: 'PORTAL'
  }
  try {
    const res = await fetchServerXBasicAuthNative(`${WIGGOT_API}/users-management/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(profileData)
    })
    return res
  } catch (error) {
    console.error('Error en fetchRemoveSession:', error)
    throw error
  }
}